// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import TabNavigation from '../../../../shared/components/tab-navigation';
import {getNavigationTabs} from '../../../shared/services/pip-navigation-helper';

const LaborAdditiveHeader = props => {

    const countObject = {
        laborAdditive: props.laborAdditivePipProductsCount,
        openPips: props.pipProductsCount,
        pipSearch: props.searchResultsCount
    };

    return (
        <header className='open-pips-header'>
            <TabNavigation
                tabs={getNavigationTabs(countObject, props.hasSearchResults, true)}
            />
        </header>
    );

};

LaborAdditiveHeader.displayName = 'OpenPipsHeader';
LaborAdditiveHeader.propTypes = {
    hasSearchResults: PropTypes.bool.isRequired,
    laborAdditivePipProductsCount: PropTypes.number.isRequired,
    pipProductsCount: PropTypes.number.isRequired,
    searchResultsCount: PropTypes.number.isRequired
};

export default LaborAdditiveHeader;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-pips-main/labor-additive-header.js